import { render, staticRenderFns } from "./CeremonyTimeline.vue?vue&type=template&id=2e4c52f2&scoped=true"
import script from "./CeremonyTimeline.vue?vue&type=script&lang=js"
export * from "./CeremonyTimeline.vue?vue&type=script&lang=js"
import style0 from "./CeremonyTimeline.vue?vue&type=style&index=0&id=2e4c52f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c52f2",
  null
  
)

export default component.exports